<mat-dialog-content>
  <p>
    You've reached the {{ data.maxNumAdds }}-item monthly limit for new items.
    Remove some old items, or
    <a
      data-toggle="modal"
      data-target="#accountSettingsDialogBox"
      href="#"
      data-dismiss="modal"
      >upgrade to Pro</a
    >
    to get unlimited space.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button cdkFocusInitial (click)="onClose()">Close</button>
</mat-dialog-actions>
